import React, { useState, useEffect } from 'react';
import Answer from '../share/Answer';
import ButtonsBlock from '../share/ButtonsBlock'
import { MultiChoiceQuestionStepProps } from '../../../types/components/user-survey/steps/MultiChoiceQuestionStep';

import { getAnswersForMultiChoiceStep, splitMultiChoiceAnswers } from '../helpers';
import { AnswerConfig } from '../../../types/components/user-survey/shared/Answer';

export const containerStyles = "flex flex-col items-center w-full"
export const questionStyles = "mb-2 text-center lg:mb-6 text-[21px] font-medium text-white"

export const mainContainerStyles = "relative w-full mb-10"
export const topFadeGradient = "absolute top-[-4px] left-0 right-0 z-10 h-4 pointer-events-none bg-gradient-to-b from-gray-900 to-transparent"
export const bottomFadeGradient = "absolute bottom-[-14px] left-0 right-2 h-6 bg-gradient-to-t from-gray-900 to-transparent z-10 pointer-events-none"

const MultiChoiceQuestionStep: React.FC<MultiChoiceQuestionStepProps> = ({
  question,
  stepIndex,
  onAnswerSelected,
  onBack,
  onNext,
  currentAnswer
}) => {
  const [selectedAnswer, setSelectedAnswer] = useState<AnswerConfig>();

  useEffect(() => {
    setSelectedAnswer(null);
  }, [stepIndex]);

  const answers = getAnswersForMultiChoiceStep(stepIndex);

  const { leftColumn, rightColumn } = splitMultiChoiceAnswers(answers);

  const handleAnswerSelected = (answer: any) => {
    setSelectedAnswer(answer);
    onAnswerSelected(answer);
  };

  return (
    <div cy-test-id="multi-choice-question-step" className={containerStyles}>
      <h2 className={questionStyles}>{question}</h2>

      <div className={mainContainerStyles}>

        <div className={topFadeGradient}></div>

        {/* Scrollable container */}
        <div className={`max-h-[400px] scrollable-div overflow-y-auto pt-2 pb-6 px-2 ${rightColumn.length > 0
            ? 'flex flex-col sm:flex-row gap-2 sm:gap-4'
            : ''
          }`}>

          <div className={`space-y-3 ${rightColumn.length > 0
              ? 'w-full sm:w-1/2'
              : 'w-full'
            }`}>
            {leftColumn.map((answer) => (
              <Answer
                key={answer.answerId}
                answer={{
                  ...answer,
                  stepIndexAfterAnswering: stepIndex + 1,
                }}
                onAnswerSelected={handleAnswerSelected}
                selectedAnswer={selectedAnswer || currentAnswer}
              />
            ))}
          </div>

          {rightColumn.length > 0 && (
            <div className="w-full mt-1 space-y-3 sm:w-1/2 sm:mt-0">
              {rightColumn.map((answer) => (
                <Answer
                  key={answer.answerId}
                  answer={{
                    ...answer,
                    stepIndexAfterAnswering: stepIndex + 1,
                  }}
                  onAnswerSelected={handleAnswerSelected}
                  selectedAnswer={selectedAnswer || currentAnswer}
                />
              ))}
            </div>
          )}
        </div>

        <div className={bottomFadeGradient}></div>
      </div>

      <ButtonsBlock
        onNext={() => (selectedAnswer || currentAnswer) && onNext()}
        nextDisabled={!selectedAnswer && !currentAnswer}
        onBack={onBack}
        nextButtonText={stepIndex === 4 && 'Submit'}
      />
    </div>
  );
};

export default MultiChoiceQuestionStep;